import { Dispatch, FC, SetStateAction } from 'react';

import { useI18nContext } from '@/i18n/I18n';

import { tabType } from '../type';
interface ITabsProps {
  activeTab: tabType;
  setActiveTab: Dispatch<SetStateAction<tabType>>;
}

const Tabs: FC<ITabsProps> = ({ activeTab, setActiveTab }) => {
  const [$t] = useI18nContext();

  return (
    <div className="oauth-admin-container-box-tab">
      <div className="tab-box">
        <div
          className={
            activeTab === tabType.CONFIG_APP ? 'active tab-item' : 'tab-item'
          }
          onClick={() => {
            setActiveTab(tabType.CONFIG_APP);
          }}
        >
          {$t('oauthAdmin.configTab')}
        </div>
        <div
          className={
            activeTab === tabType.SECRET_KEY ? 'active tab-item' : 'tab-item'
          }
          onClick={() => {
            setActiveTab(tabType.SECRET_KEY);
          }}
        >
          {$t('oauthAdmin.secretTab')}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
